import { c as _c } from "react-compiler-runtime";
import I18n from 'I18n';
import Raven from 'raven-js';
import { useState } from 'react';
import { showErrorNotification } from '../utils/notifications';
const FAILED_TO_CALL_ONREADY_KEY = 'Failed to call the onReady on the collaboration sidebar embedded app';
export default function useHandleIFrameError(props) {
  "use memo";

  const $ = _c(8);
  const onContentErrorRef = props && props.onContentErrorRef;
  const [IFrameError, setIFrameError] = useState(null);
  let t0;
  if ($[0] !== onContentErrorRef) {
    t0 = error => {
      setIFrameError(error);
      showErrorNotification({
        message: I18n.text("collaborationSidebar.notifications.failure.collaborationSidebar"),
        sticky: true
      });
      if (onContentErrorRef && onContentErrorRef.current) {
        onContentErrorRef.current(error);
      }
    };
    $[0] = onContentErrorRef;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleSidebarInitError = t0;
  let t1;
  if ($[2] !== onContentErrorRef) {
    t1 = error_0 => {
      setIFrameError(error_0);
      showErrorNotification({
        message: I18n.text("collaborationSidebar.notifications.failure.collaborationSidebar"),
        sticky: true
      });
      Raven.captureException(new Error(FAILED_TO_CALL_ONREADY_KEY, {
        cause: error_0
      }), {
        fingerprint: [FAILED_TO_CALL_ONREADY_KEY]
      });
      if (onContentErrorRef && onContentErrorRef.current) {
        onContentErrorRef.current(error_0);
      }
    };
    $[2] = onContentErrorRef;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSidebarReadyError = t1;
  let t2;
  if ($[4] !== IFrameError || $[5] !== handleSidebarInitError || $[6] !== handleSidebarReadyError) {
    t2 = {
      handleSidebarInitError,
      handleSidebarReadyError,
      IFrameError
    };
    $[4] = IFrameError;
    $[5] = handleSidebarInitError;
    $[6] = handleSidebarReadyError;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}